import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProfileRoutes } from 'app/profile/routes/profile-routes';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(ProfileRoutes)
  ],
  exports: [RouterModule]
})
export class ProfileRoutingModule { }
